<template>
  <div v-if="pagesCount && pagesCount > 1">
    <nav
      class="relative z-0 flex w-full justify-center gap-x-4"
      aria-label="Pagination"
    >
      <button
        v-if="currentPage === 1"
        :class="[arrowClass, 'text-slate opacity-20']"
      >
        <span class="sr-only">Previous</span>
        <UiIcon icon="chevronLeft" class="h-3 w-3" aria-hidden="true" />
      </button>
      <NuxtLink
        v-else
        :class="[arrowClass, 'text-blue']"
        :to="linkToPage(+currentPage > 2 ? +currentPage - 1 : null)"
      >
        <span class="sr-only">Previous</span>
        <UiIcon icon="chevronLeft" class="h-3 w-3" aria-hidden="true" />
      </NuxtLink>

      <!-- span.contents keeps the flex layout and lets v-for stay off <template> -->
      <span v-for="page in visiblePages" :key="page.index" class="contents">
        <span
          v-if="page.breakView"
          class="relative inline-flex h-12 w-12 items-center justify-center border border-transparent text-slate-lighten4"
        >
          ...
        </span>

        <NuxtLink
          v-else
          class="relative inline-flex h-12 w-12 items-center justify-center rounded-full transition hover:text-blue"
          :class="{
            'text-blue': +currentPage === page.content,
            'text-slate-lighten4': +currentPage !== page.content,
          }"
          :to="linkToPage(page.index > 0 ? page.index + 1 : undefined)"
        >
          {{ page.content }}
        </NuxtLink>
      </span>

      <NuxtLink
        v-if="+currentPage < pagesCount"
        :class="[arrowClass, 'text-blue']"
        tabindex="0"
        :to="linkToPage(+currentPage + 1)"
      >
        <span class="sr-only">Next</span>
        <UiIcon icon="chevronRight" class="h-3 w-3" aria-hidden="true" />
      </NuxtLink>
      <button
        v-else
        :class="[arrowClass, 'text-slate opacity-20']"
        disabled
        tabindex="0"
      >
        <span class="sr-only">Next</span>
        <UiIcon icon="chevronRight" class="h-3 w-3" aria-hidden="true" />
      </button>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { usePagination } from '~/composables';

interface Props {
  pagesCount?: number | null;
  currentPage?: number | string;
  marginPages?: number;
  pageRange?: number;
}
const props = withDefaults(defineProps<Props>(), {
  pagesCount: null,
  currentPage: 1,
  marginPages: 1,
  pageRange: 3,
});

const route = useRoute();
const query = computed(() => route.query);
const { pagination } = usePagination({ ...props } as any);
const visiblePages = computed(() => (pagination.value || []).filter(Boolean));
const arrowClass =
  'relative inline-flex h-12 w-12 items-center justify-center rounded-full border border-blue transition';

const linkToPage = (page: any) => ({ query: { ...query.value, page } });
</script>
